import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { I18nProvider } from './i18n'
import './index.css'

const disableReactDevtoolsInProd = () => {
  if (!import.meta.env.PROD || typeof window === 'undefined') return
  const hook = (window as Window & { __REACT_DEVTOOLS_GLOBAL_HOOK__?: { isDisabled?: boolean } })
    .__REACT_DEVTOOLS_GLOBAL_HOOK__
  if (hook) {
    hook.isDisabled = true
  }
}

disableReactDevtoolsInProd()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
)
